const routes = [
  {
    path: 'aggridapi',
    name: 'aggridapi',
    component: () => import(/* webpackChunkName: "aggridapi" */ '@/modules/aggridapi/index.vue')
  },
];

export default routes;